// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Account } from './ui/account.model';
import { CustomCaseFieldValue } from './custom-case-field-value.model';
import { LifeCycle } from './lifecycle.model';
import { ByteSize } from './byte-size.model';
import { User } from './ui/user.model';

export class LexbeCase {
	caseId: string;
	simpleCaseId: number;
	accountId: string;
	account: Account;
	caseName: string;
	caseNumber: string;
	caseType: string;
	caseVenue: string;
	leadAttorney: string;
	trierOfFact: string;
	customDesignation: string;
	caseComments: string;
	caseDocCount: number;
	caseKeywords: string;
	indexDocCount: number;
	currentCaseSizeBytes: number;
	docSize: number;
	productionJobSize: number;
	archiveJobSize: number;
	downloadSize: number;
	indexSize: number;
	lifecycle: LifeCycle;
	customFields: CustomCaseFieldValue[];
	displayTotalCaseSize: ByteSize;
	dateTimeCreated: string;
	users: User[];
	createdById: string;
	createdBy: User;
	useGigabytes: boolean;

	static addComputedFields(lexbeCase: LexbeCase) {
		if (!lexbeCase.displayTotalCaseSize) {
			lexbeCase.displayTotalCaseSize = new ByteSize(lexbeCase.currentCaseSizeBytes);
		}
	}
}
